import { render, staticRenderFns } from "./bannerlist.vue?vue&type=template&id=66f4917c"
import script from "./bannerlist.vue?vue&type=script&lang=js"
export * from "./bannerlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports